// Generated by purs version 0.15.0
import * as Data_Bounded_Generic from "../Data.Bounded.Generic/index.js";
import * as Data_Enum_Generic from "../Data.Enum.Generic/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
var Available = /* #__PURE__ */ (function () {
    function Available() {

    };
    Available.value = new Available();
    return Available;
})();
var TemporarilyUnavailable = /* #__PURE__ */ (function () {
    function TemporarilyUnavailable() {

    };
    TemporarilyUnavailable.value = new TemporarilyUnavailable();
    return TemporarilyUnavailable;
})();
var Hidden = /* #__PURE__ */ (function () {
    function Hidden() {

    };
    Hidden.value = new Hidden();
    return Hidden;
})();
var eqAvailability = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Available && y instanceof Available) {
                return true;
            };
            if (x instanceof TemporarilyUnavailable && y instanceof TemporarilyUnavailable) {
                return true;
            };
            if (x instanceof Hidden && y instanceof Hidden) {
                return true;
            };
            return false;
        };
    }
};
var ordAvailability = {
    compare: function (x) {
        return function (y) {
            if (x instanceof Available && y instanceof Available) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Available) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Available) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof TemporarilyUnavailable && y instanceof TemporarilyUnavailable) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof TemporarilyUnavailable) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof TemporarilyUnavailable) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Hidden && y instanceof Hidden) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.Availability (line 29, column 1 - line 29, column 33): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqAvailability;
    }
};
var genericAvailability = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Available.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return TemporarilyUnavailable.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return Hidden.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.Availability (line 15, column 1 - line 15, column 79): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Available) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof TemporarilyUnavailable) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Hidden) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.Availability (line 15, column 1 - line 15, column 79): " + [ x.constructor.name ]);
    }
};
var showAvailability = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericAvailability)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Available";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "TemporarilyUnavailable";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Hidden";
        }
    }))))
};
var unscrambleDecodeAvailability = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericAvailability)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Available";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "TemporarilyUnavailable";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Hidden";
        }
    }))))(Unscramble_Enum.defaultEnumOptions)
};
var boundedAvailability = {
    top: /* #__PURE__ */ Data_Bounded_Generic.genericTop(genericAvailability)(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments)))),
    bottom: /* #__PURE__ */ Data_Bounded_Generic.genericBottom(genericAvailability)(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments))),
    Ord0: function () {
        return ordAvailability;
    }
};
var enumAvailability = {
    succ: /* #__PURE__ */ Data_Enum_Generic.genericSucc(genericAvailability)(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments)))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments)))),
    pred: /* #__PURE__ */ Data_Enum_Generic.genericPred(genericAvailability)(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments)))(/* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(/* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments)))),
    Ord0: function () {
        return ordAvailability;
    }
};
var boundedEnumAvailability = {
    cardinality: /* #__PURE__ */ Data_Enum_Generic.genericCardinality(genericAvailability)(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments)))),
    toEnum: /* #__PURE__ */ Data_Enum_Generic.genericToEnum(genericAvailability)(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments)))),
    fromEnum: /* #__PURE__ */ Data_Enum_Generic.genericFromEnum(genericAvailability)(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments))(/* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments)))),
    Bounded0: function () {
        return boundedAvailability;
    },
    Enum1: function () {
        return enumAvailability;
    }
};
var encodeAvailability = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericAvailability)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Available";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "TemporarilyUnavailable";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Hidden";
        }
    }))))
};
var decodeAvailability = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericAvailability)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Available";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "TemporarilyUnavailable";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Hidden";
        }
    }))))
};
export {
    Available,
    TemporarilyUnavailable,
    Hidden,
    genericAvailability,
    eqAvailability,
    showAvailability,
    encodeAvailability,
    decodeAvailability,
    unscrambleDecodeAvailability,
    ordAvailability,
    enumAvailability,
    boundedAvailability,
    boundedEnumAvailability
};
//# sourceMappingURL=index.js.map
